export default {
  dealHome: {
    Headers: {
      title: 'Review Order Information',
      Delivery: 'Delivery Information',
      urchasing: "Purchase List",
      merchant: "Merchant",
      notSelfMention: "Delivery unavailable in this region. Please change shipping address!",
      shopingMention: "Non-deliverable items",
      notSelfpickup: "Some items cannot be picked up",
      shopingpickup: "Items unavailable for pickup",
      paymentmethod: "Payment Method",
      dialogTitle: "Shipping Address",
      thrxx: "Pickup Person Information",
      title1: 'Payment',
      title2: 'Invoice Payment',
      title3: 'Order submitted! Please complete payment soon.',
      title4: 'Subtotal',
      title5: 'Complete payment within ',
      title6: ', or order will be automatically canceled',
      title7: 'Product Name',
      title8: "Select payment method",
      title9: "Submission Successful",
      title10: "Payment Successful",
      title11: "Order Paid Successfully",
    },
    rules: {
      cityData: "Please select location",
      address: "Please enter detailed address",
      address1: "Please enter 4-50 character detailed address",
      code: "Please enter postal code",
      name: "Please enter pickup person name",
      name1: "Please enter 2-10 character pickup person name",
      tel: "Please enter mobile number",
      tel1: "Please enter valid mobile number",
      consigneeName: "Please enter 2-10 character pickup person name",
      password: "Please enter correct password"
    },
    Message: {
      messagexg: "Modified successfully!",
      messagetj: "Submitted successfully!",
      errorsh: "Please select shipping information",
      msgpaywayZqzf: "Insufficient credit balance",
      msgpaywayZqzf1: "Current order amount",
      msgpaywayZqzf2: "Available credit balance",
      urls: "Please upload payment receipt",
      messageurls: "Copied",
      messageurls1: "Copy failed",
    },
    Alert: {
      AlertTitle: "Notice",
      AlertBox: "Maximum address limit reached. Cannot add new addresses.",
    },
    Button: {
      Merchant: 'Merchant Delivery',
      pickup: 'Customer Pickup',
      modifyAddress: "Edit Address",
      newlyAddress: "Add New Address",
      details: "Details",
      details1: "Order Details",
      addressList: "Change Shipping Address",
      returnorder: "Back to Order",
      orderAdd: "Place Order",
      cancelBtn: "Cancel",
      saveBtn: "Save",
      saveBtn1: "Confirm",
      saveBtn2: "Full Payment",
      saveBtn3: "Staged Payment",
      saveBtn4: "Credit Payment",
      saveBtn5: "Quick Pay",
      saveBtn6: "Corporate Payment",
      saveBtn7: "Offline Payment",
      saveBtn8: "Confirm Payment",
      saveBtn9: "View Order",
      saveBtn10: "Continue Shopping",
      saveBtn11: "Back to Invoice",
      saveBtn12: "Pay Now",
      saveBtn13: "Back",
    },
    form: {
      name: 'Recipient',
      name1: "Recipient Name",
      tel: "Contact Number",
      address: "Shipping Address",
      shopName: "Pickup Point",
      addrDetail: "Pickup Address",
      consigneeName: "Pickup Person",
      consigneeTel: "Mobile Number",
      depositFirst: "Pay Deposit First",
      goodstotal: "Total Items",
      goodstnum: "Subtotal",
      fareAmount1: 'Shipping Fee',
      payableAmount: 'Amount Due',
      paidAmount: "Deposit Due",
      paidAmount1: "Deposit Paid",
      balanceAmount: "Balance Due",
      fareAmount: "Shipping",
      orderAmount: "Order Total",
      depositAmount: "Deposit Amount",
      cityData: 'Region',
      Dataaddress: "Detailed Address",
      code: "Postal Code",
      defaultaddress: "Default Address",
      changeAddFlagaddress: 'Select Shipping Address',
      orderNum: 'Order No.',
      availableCredit: 'Available Credit',
      password: 'Payment Password',
      passwordwj: 'Forgot Password',
      countDowns: "00h 00m 00s",
      hour: "h",
      min: "m",
      sec: "s",
      orderNum1: "Order Number",
      payAmount: "Payment Amount"
    },
    steps: {
      Operationsteps: "Instructions",
      Operationsteps1: "1. Open mobile banking app/online banking, or visit bank counter",
      Operationsteps2: "2. Transfer payment to the following account",
      Operationsteps3: "Beneficiary Account",
      Operationsteps4: "Copy",
      bankCardNo: "Account Number",
      entpName: "Account Name",
      remarks: "Bank Name",
      Operationsteps5: "3. System will automatically verify payment upon receipt.",
      Operationsteps6: "4. Processing time: ~2 hours (business days). Delays may occur on non-business days.",
      Operationsteps7: "Upload Payment Receipt",
      uploadDate: "Upload Time",
      xxzffz: "After offline payment, upload receipt here. Ensure receipt details are clear.",
      Operationsteps8: "1. Transfer amount MUST match order total exactly.",
      Operationsteps9: "2. Processing time: Check payment status after 30 mins. Typically 2 hours during business days.",
      Operationsteps10: "Payment Instructions",
      Operationsteps11: "1. Method 1: Click 'Pay Now' and complete payment",
      Operationsteps12: "2. Method 2: Copy secure payment link below for finance team to complete payment",
      Operationsteps13: "Copy Payment Link",
      Operationsteps14: "3. System will auto-verify payment upon receipt.",
    },
    Description: {
      placeholdermsg: 'Contact merchant for shipping fee disputes',
      noData: 'Message to seller',
      addressChecked: "Set as default address",
      msg: "This address will auto-select during checkout",
      placeholdermsg1: "Enter recipient name",
      placeholdermsg2: "Enter contact number",
      placeholdermsg3: "Complete detailed address",
      placeholdermsg4: "Enter postal code",
      submitsuccess: "Order submitted! Awaiting merchant confirmation.",
      wxts: "Reminder: Keep phone available for delivery. Platform will NEVER ask for refunds via external links.",
      jsdzfcg: "Payment successful! Check invoice status for verification if needed."
    },
    Table: {
      headerName: ['Product', 'Specs', 'Qty', 'Unit Price', 'Subtotal'],
    }
  }
}